import { takeLatest, put } from 'redux-saga/effects'
import request from '@/helpers/axios'
import {
  GET_ALL_APPLICATIONS_FILES,
  successAllApplicationsFiles
} from '@/store/actions/appSettings'
import createNotifications from "@/helpers/notification";
import { GET_ALL_APPLICATIONS_FILE_URL } from '@/constants/apiRoutes';


function* getAllApplicationsFile() {
  try {
    const { data } = yield request({
      url: GET_ALL_APPLICATIONS_FILE_URL,
      method: 'get',
    })
    yield put(successAllApplicationsFiles(data))
  } catch (error) {
    console.log('TCL: function*addWidgetToGeneralPage -> error', error)
    const toast = createNotifications()
    toast({
      title: 'Ошибка операции!',
      description: 'Повторите попытку позже.',
      type: 'error',
    })
  }
}

export default function* () {
  yield takeLatest(GET_ALL_APPLICATIONS_FILES.REQUEST, getAllApplicationsFile)
}
